import React from 'react';
import { Stack, Typography, Chip } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';

const SectionLabel = ({ label, note, instant }) => (
  <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
    <Typography variant="caption"
      sx={{ color: '#4FC3F7', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, fontSize: 11 }}>
      {label}
    </Typography>
    {note && (
      <Typography variant="caption" sx={{ color: '#546E7A', fontSize: 10 }}>{note}</Typography>
    )}
    {instant && (
      <Chip
        icon={<BoltIcon sx={{ fontSize: '10px !important', ml: '4px !important' }} />}
        label="Instant" size="small"
        sx={{ height: 16, fontSize: 9, backgroundColor: '#1B3A1B', color: '#66BB6A', border: '1px solid #66BB6A' }}
      />
    )}
  </Stack>
);

export default SectionLabel;